import { Select } from '@chakra-ui/react'
import { VitalSource, VitalSourceKey } from '@hb/shared'
import { useField } from 'react-final-form'

interface Props {
  vitalKey: VitalSourceKey
  isTelehealth: boolean
}

// §H: Inline source selector that appears next to each vital input on telehealth visits only.
// "Provider measured" is the default (stored as absence of key — nothing written to Firestore).
// "Patient self-reported — home device" writes 'pt-reported' to data.vitalSources[vitalKey].
export const VitalSourceSelect = ({ vitalKey, isTelehealth }: Props) => {
  const {
    input: { value: sources, onChange },
  } = useField<Partial<Record<VitalSourceKey, VitalSource>> | undefined>('data.vitalSources', {
    subscription: { value: true },
  })

  if (!isTelehealth) return null

  const currentValue: string = sources?.[vitalKey] ?? ''

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const next = e.target.value as VitalSource | ''
    const updated = { ...(sources ?? {}) }
    if (next === 'pt-reported') {
      updated[vitalKey] = 'pt-reported'
    } else {
      delete updated[vitalKey]
    }
    onChange(Object.keys(updated).length > 0 ? updated : undefined)
  }

  return (
    <Select
      size="xs"
      value={currentValue}
      onChange={handleChange}
      maxW="200px"
      mt={1}
      variant="outline"
      opacity={0.75}
      _focus={{ opacity: 1 }}
      fontSize="xs"
      color="gray.600"
      borderColor="gray.300">
      <option value="">Provider measured</option>
      <option value="pt-reported">Patient self-reported — home device</option>
    </Select>
  )
}
